import React, { useEffect, useState } from 'react';
import Button from '../../common/Button';
import InputBox from '../../common/InputBox';
import ToastNotification from '../../common/ToastNotification';
import Lopa from '../../assets/LopaaLogo.png';
import { forgotPassword } from '../../api/Auth';
import { validateForm } from '../../function/FormValidation';

const ForgotPassword = () => {
  const [formData, setFormData] = useState({ email: '' });
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isFormValid, setIsFormValid] = useState<boolean>(false);
  const [disableBtn, setDisableBtn] = useState<boolean>(false);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const { isValid, errors } = validateForm(formData, ['email']);
    setErrors(errors);
    if (isValid) {
      setDisableBtn(true);
      try {
        const response = await forgotPassword({
          email: formData.email || ''
        });
        if (response.ok) {
          const data = await response.json();
          ToastNotification({
            message: data.message
          });
          setTimeout(() => {
            setFormData({
              email: ''
            });
            setDisableBtn(false);
          }, 1500);
        } else {
          const errorData = await response.json();
          ToastNotification({
            message: errorData.message,
            type: 'warning'
          });
          setDisableBtn(false);
        }
      } catch (error: any) {}
    }
  };

  useEffect(() => {
    const validateForm = () => {
      setIsFormValid(!!formData.email);
    };
    validateForm();
  }, [formData]);

  return (
    <>
      <img
        src={Lopa}
        className="lg:w-32 lg:h-[60px] w-[101px] h-12 mr-2 ml-8 mt-8"
        alt="Matrix AI"
      />
      <div className="">
        <div className="flex min-h-full flex-col justify-center px-2 py-3 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-lg md:mt-5">
            <h2 className="mt-5 text-start text-base md:text-[36px] md:leading-[50.33px] font-bold tracking-tight">
              Forget Password?
            </h2>

            <p className="mt-5 justify-center tracking-tight text-xl md:text-[20px] md:leading-[27.36px]">
              Enter your email address below, and we’ll send you a link to reset your password.
            </p>
          </div>

          <div className="mt-3  sm:mx-auto sm:w-full sm:max-w-lg">
            <form onSubmit={handleSubmit} action="/reset-password" className="space-y-3">
              <div>
                <div className="mt-5">
                  <InputBox
                    name="email"
                    type="email"
                    value={formData.email}
                    placeholder="Enter your Email"
                    handleChange={handleChange}
                    error={errors.email}
                  />
                </div>
              </div>

              <div className="flow-root">
                <Button
                  isFormValid={isFormValid}
                  btnText="Send"
                  textColor="#FFFFFF"
                  backGroundColor="#006BEA"
                  borderColor=""
                  disable={disableBtn}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
